"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
var React = __importStar(require("react"));
var utils_1 = require("../../utils");
var types_1 = require("../../types");
var Modal_style_1 = require("./Modal.style");
exports.Modal = function (_a) {
    var _b, _c;
    var id = _a.id, Component = _a.Component, config = _a.config;
    var _d = React.useState(false), isAnimationDone = _d[0], setIsAnimationDone = _d[1];
    var _e = React.useState(false), isClosing = _e[0], setIsClosing = _e[1];
    var _f = utils_1.useFusionContext(), state = _f.state, dispatch = _f.dispatch;
    var refContainer = React.useRef(null);
    var refModal = React.useRef(null);
    React.useEffect(function () {
        var container = refContainer.current;
        var modal = refModal.current;
        if (container && modal) {
            utils_1.animate(function (value) { return (container.style.opacity = value); }, { from: parseFloat(container.style.opacity), to: 1 });
            utils_1.animate(function (value) { return (modal.style.transform = "scale(" + value + ")"); }, {
                from: utils_1.sliceFloat(modal.style.transform),
                to: 1,
                onRest: function () { return setIsAnimationDone(true); }
            });
        }
    }, []);
    var closeModal = function () {
        if (isAnimationDone) {
            setIsClosing(true);
            var container_1 = refContainer.current;
            var modal_1 = refModal.current;
            if (container_1 && modal_1) {
                utils_1.animate(function (value) { return (container_1.style.opacity = value); }, { from: parseFloat(container_1.style.opacity), to: 0 });
                utils_1.animate(function (value) { return (modal_1.style.transform = "scale(" + value + ")"); }, {
                    from: utils_1.sliceFloat(modal_1.style.transform),
                    to: 0,
                    onRest: function () { return dispatch({ type: types_1.ActionType.REMOVE_MODAL, payload: id }); }
                });
            }
        }
    };
    var closeIfContainer = function (e) {
        if (e.target.dataset.autoclose === "true") {
            closeModal();
        }
    };
    return (React.createElement("div", { ref: refContainer, className: (_b = state.modalClassNames) === null || _b === void 0 ? void 0 : _b.container, style: __assign(__assign({}, Modal_style_1.containerStyles), { cursor: (config === null || config === void 0 ? void 0 : config.autoclose) ? "pointer" : undefined }), onClick: (config === null || config === void 0 ? void 0 : config.autoclose) ? function (e) { return closeIfContainer(e); } : undefined, "data-autoclose": config === null || config === void 0 ? void 0 : config.autoclose },
        React.createElement("div", { ref: refModal, className: (_c = state.modalClassNames) === null || _c === void 0 ? void 0 : _c.modal, style: Modal_style_1.modalStyles }, React.useMemo(function () { return (React.createElement(Component, __assign({}, __assign({ closeModal: closeModal, isAnimationDone: isAnimationDone, isClosing: isClosing }, config === null || config === void 0 ? void 0 : config.props)))); }, [closeModal, isAnimationDone, isClosing]))));
};
